import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { clientRoute } from '../route';

import { clientEventsNewValidateSearchSchema } from './helpers/clientEventsNewValidateSearchSchema';

export const clientEventsNewRoute = createRoute({
	getParentRoute: () => clientRoute,
	path: '/events-new',
	component: lazyRouteComponent(
		() => import('./ClientEventsNewPage'),
		'ClientEventsNewPage',
	),
	validateSearch: clientEventsNewValidateSearchSchema,
});
